// public-path.js

// 1. Resolve your path safely
const targetPublicPath = window.ShipBobConfig?.distUrl ?? '/wp-content/themes/shipbob-2022/dist/';

// 2. Set the standard Webpack keyword for normal dynamic imports
__webpack_public_path__ = targetPublicPath;

// 3. FORCE update the separate runtime chunk tracking property
if (typeof __webpack_require__ !== 'undefined') {
    __webpack_require__.p = targetPublicPath;
}